export default "__VITE_ASSET__nmbPlLJZ__"